/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Zoom_Out_TitleInputs */

const en_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom Out`)
};

const fr_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezoomer`)
};

const de_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herauszoomen`)
};

const it_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimpicciolisci`)
};

const ru_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отдалиться`)
};

const es_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alejar`)
};

const zh_cn2_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩小`)
};

const ja_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームアウト`)
};

const hi_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम आउट`)
};

const pt_pt2_timeline_zoom_out_title = /** @type {(inputs: Timeline_Zoom_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuir o zoom`)
};

/**
* | output |
* | --- |
* | "Zoom Out" |
*
* @param {Timeline_Zoom_Out_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_zoom_out_title = /** @type {((inputs?: Timeline_Zoom_Out_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Zoom_Out_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_zoom_out_title(inputs)
	if (locale === "de") return de_timeline_zoom_out_title(inputs)
	if (locale === "it") return it_timeline_zoom_out_title(inputs)
	if (locale === "ru") return ru_timeline_zoom_out_title(inputs)
	if (locale === "es") return es_timeline_zoom_out_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_zoom_out_title(inputs)
	if (locale === "ja") return ja_timeline_zoom_out_title(inputs)
	if (locale === "hi") return hi_timeline_zoom_out_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_zoom_out_title(inputs)
	return en_timeline_zoom_out_title(inputs)
});